"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbToastr = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _TransitionGroup = _interopRequireDefault(require("react-transition-group/TransitionGroup"));

var _CSSTransition = _interopRequireDefault(require("react-transition-group/CSSTransition"));

var _shapes = require("../../skybase-core/shapes");

var _sbToast = require("./sb-toast");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP_LEFT = _constants.toastrPositions.TOP_LEFT,
    TOP_RIGHT = _constants.toastrPositions.TOP_RIGHT,
    BOTTOM_RIGHT = _constants.toastrPositions.BOTTOM_RIGHT,
    BOTTOM_LEFT = _constants.toastrPositions.BOTTOM_LEFT;

var _SbToastr = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbToastr, _PureComponent);

  var _super = _createSuper(_SbToastr);

  function _SbToastr() {
    _classCallCheck(this, _SbToastr);

    return _super.apply(this, arguments);
  }

  _createClass(_SbToastr, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          position = _this$props.position,
          style = _this$props.style,
          timeout = _this$props.timeout,
          toasts = _this$props.toasts,
          removeToast = _this$props.removeToast,
          hideTime = _this$props.hideTime,
          _ = _this$props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "toastr ".concat(position),
        style: style
      }, /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, null, toasts.map(function (toast) {
        var className = toast.className,
            id = toast.id,
            message = toast.message,
            title = toast.title,
            type = toast.type,
            toastHideTime = toast.hideTime,
            config = _objectWithoutProperties(toast, ["className", "id", "message", "title", "type", "hideTime"]);

        var toastMessage = (0, _utils.getToastString)(message, _);
        var toastTitle = (0, _utils.getToastString)(title, _);
        return /*#__PURE__*/_react.default.createElement(_CSSTransition.default, {
          key: "toast-animation-".concat(id),
          classNames: "toast-animation",
          timeout: timeout
        }, /*#__PURE__*/_react.default.createElement(_sbToast.SbToast, _extends({
          toastId: id,
          className: className,
          message: toastMessage,
          title: toastTitle,
          type: type,
          removeToast: removeToast,
          hideTime: toastHideTime || hideTime
        }, config)));
      })));
    }
  }]);

  return _SbToastr;
}(_react.PureComponent);

_defineProperty(_SbToastr, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  position: _propTypes.default.oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT, BOTTOM_LEFT]),
  style: _propTypes.default.object,
  // eslint-disable-line
  toasts: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.object), _propTypes.default.object]).isRequired,
  hideTime: _propTypes.default.number,
  timeout: _propTypes.default.shape({
    enter: _propTypes.default.number.isRequired,
    exit: _propTypes.default.number.isRequired
  }),
  removeToast: _propTypes.default.func
});

_defineProperty(_SbToastr, "defaultProps", {
  position: TOP_RIGHT,
  style: null,
  hideTime: 5000,
  timeout: {
    enter: 400,
    exit: 200
  },
  removeToast: null
});

var SbToastr = (0, _reactIntl.injectIntl)(_SbToastr);
exports.SbToastr = SbToastr;
//# sourceMappingURL=sb-toastr.js.map